import type { PermissionLevel, PermissionModule } from '@/types'

/** Exact match against Spatie permission names (e.g. `clients.view`). */
export function hasPermission(
  permissions: string[] | undefined | null,
  name: string
): boolean {
  if (!permissions?.length) return false
  return permissions.includes(name)
}

export function canViewModule(
  permissions: string[] | undefined | null,
  module: PermissionModule
): boolean {
  return hasPermission(permissions, `${module}.view`)
}

export function canEditModule(
  permissions: string[] | undefined | null,
  module: PermissionModule
): boolean {
  return hasPermission(permissions, `${module}.edit`)
}

export function canDeleteModule(
  permissions: string[] | undefined | null,
  module: PermissionModule
): boolean {
  return hasPermission(permissions, `${module}.delete`)
}

/** Derive the matrix level for a module from a flat permissions list. */
export function moduleLevelFromPermissions(
  permissions: string[] | undefined | null,
  module: PermissionModule
): PermissionLevel {
  if (canDeleteModule(permissions, module)) return 'full_access'
  if (canEditModule(permissions, module)) return 'edit'
  if (canViewModule(permissions, module)) return 'view_only'
  return 'no_access'
}

export type ModuleAction = 'view' | 'edit' | 'delete'

export function canModuleAction(
  permissions: string[] | undefined | null,
  module: PermissionModule,
  action: ModuleAction
): boolean {
  switch (action) {
    case 'view':
      return canViewModule(permissions, module)
    case 'edit':
      return canEditModule(permissions, module)
    case 'delete':
      return canDeleteModule(permissions, module)
  }
}
